import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { getBitacoraRequisicionHttp } from "actions/requisiciones";
import { getBitacoraOrdenCompraHttp, getOrdenesCompraHttp } from "actions/ordenCompra";

export interface DetalleOrdenCompra {
  id: number;
  id_inventario: number;
  nombre_producto: string;
  cantidad: string;
  precio: string;
  precio_total: string;
  comentarios: string;
  estatus: number;
}

export const useOrdenCompra = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);

  const [procesando, setProcesando] = useState<boolean>(true);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const [errorLogin, setErrorLogin] = useState(false);
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  const [ordenesCompra, setOrdenesCompra] = useState<any[]>([]);

  // Estados para la paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [detalles, setDetalles] = useState<DetalleOrdenCompra[]>([]);

  //Modal de ver detalles de la orden de compra
  const [verDetalleOrdenCompra, setVerDetalleOrdenCompra] = useState<any>(null);
  const [isAlertOpenDetalleOrdenCompra, setIsAlertOpenDetalleOrdenCompra] = useState(false);
  const handleisAlertOpenDetalleOrdenCompra = () => setIsAlertOpenDetalleOrdenCompra(true);
  const handleisAlertCloseDetalleOrdenCompra = () => setIsAlertOpenDetalleOrdenCompra(false);

  //obtener bitacora de orden de compra
  const [bitacora, setBitacora] = useState<any[]>([]);
  const [isAlertOpenBitacora, setIsAlertOpenBitacora] = useState(false);
  const handleisAlertOpenBitacora = () => setIsAlertOpenBitacora(true);
  const handleisAlertCloseBitacora = () => setIsAlertOpenBitacora(false);

  const getOrdenesCompra = useCallback(async () => {
    try {
      setProcesando(true);
      const ordenesCompra = await getOrdenesCompraHttp();
      setOrdenesCompra(ordenesCompra);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  useEffect(() => {
    getOrdenesCompra();
  }, []);

  const ordenesCompraPaginadas = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return ordenesCompra?.slice(startIndex, endIndex) || [];
  }, [ordenesCompra, page, rowsPerPage]);

  //bitacora de orden de compra
  const getBitacoraOrdenCompra = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const response = await getBitacoraOrdenCompraHttp(datos);
      setBitacora(response);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  return {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    ordenesCompra,
    ordenesCompraPaginadas,
    idUsuario,
    // productos
    detalles,
    setDetalles,
    //ver detalles de la requisicion
    isAlertOpenDetalleOrdenCompra,
    handleisAlertOpenDetalleOrdenCompra,
    handleisAlertCloseDetalleOrdenCompra,
    verDetalleOrdenCompra,
    setVerDetalleOrdenCompra,
    //mostrar bitacora de orden de compra
    getBitacoraOrdenCompra,
    bitacora,
    setBitacora,
    isAlertOpenBitacora,
    handleisAlertOpenBitacora,
    handleisAlertCloseBitacora,
  };
};
